
<div class="modal-header">
  <p class="modal-title">
    <strong>Recruitment History - Changes in critical fields</strong>
  </p>

  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="modal.dismiss()">
  </button>
</div>


<div class="px-3 py-2">
  <label class="form-label mb-1"><b>Search filter</b></label>
  <input
    type="text"
    class="form-control form-control-sm"
    placeholder="Field Name"
    style="width: 220px;"
    [(ngModel)]="searchText"
  />
</div>


<div class="modal-body pt-2">
  <table class="table table-sm table-bordered">
    <thead>
      <tr>
        <th>Field Name</th>
        <th>Modified By</th>
        <th>Modified On</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let row of filteredRows">
        
         
          <td>{{ getFieldLabel(row.fieldName) }}</td>
        <td>{{ row.modifiedBy }}</td>
        <!-- <td>{{row.modifiedOn | date:'dd/MM/yyyy HH:mm' }}</td> -->
          <td>{{row.modifiedOn  }}</td>
      </tr>

   
      <tr *ngIf="filteredRows.length === 0">
        <td colspan="3" class="text-center text-muted">
          No matching records found
        </td>
      </tr>
    </tbody>
  </table>
</div>
